/*
 * @Description 组件 LicenseDropDown 授头部权
 * @Author 
 * @Date 
 */
/* HTML */
<template>
    <div>
    	<el-dropdown type="primary" trigger="click">
            <span class="iconfont el-icon-my_ziyuan2 cursor-pointer" style="font-size: 20px;" title="页面缩放" />
            <el-dropdown-menu slot="dropdown"  style="padding: 10px;">
              <span>屏幕适配：</span>
              <el-button-group v-if="zoomButton">
                <el-button class="el-icon-minus" type="info" size="mini" @click="upDownZoom(false)"></el-button>
                <el-button type="info" size="mini" @dblclick.native="updateZoom">{{ zoom }}%</el-button>
                <el-button class="el-icon-plus" type="info" size="mini" @click="upDownZoom(true)"></el-button>
              </el-button-group>
              <el-button-group v-else>
                <el-input v-model="zoom" type="text" @blur="finishUpdate" style="width:100px;"/> %
              </el-button-group>
            </el-dropdown-menu>
	    </el-dropdown>
	    

    </div>
</template>

/* JS */
<script>

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "ScreenScale",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
          minZoom: 50,
          maxZoom: 150,
          zoom: 100,
          zoomButton: true,
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 初始化
			this.initZoom();
		},// mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date
		 */
		beforeDestroy() {

		},// beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date
		 */
		destroyed() {

		},// destroyed

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date
		 */
		methods: {
		  /**
		   * @Author ZhangBin
		   * @Description //TODO 初始化放大级别
		   * @Date 17:33 2022/8/26
		   * @Param
		   * @return
		   **/
		  initZoom(){
		  	// return false;
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 1000){
          this.zoom = 50;
        }else if(screenWidth >= 1000 && screenWidth < 1100){
          this.zoom = 55;
        }else if(screenWidth >= 1100 && screenWidth < 1200){
          this.zoom = 60;
        }else if(screenWidth >= 1200 && screenWidth < 1300){
          this.zoom = 65;
        }else if(screenWidth >= 1300 && screenWidth < 1400){
          this.zoom = 70;
        }else if(screenWidth >= 1400 && screenWidth < 1500){
          this.zoom = 75;
        }else if(screenWidth >= 1500 && screenWidth < 1600){
          this.zoom = 80;
        }else if(screenWidth >= 1600 && screenWidth < 1800){
          this.zoom = 85;
        }else if(screenWidth >= 1800 && screenWidth < 1920){
          this.zoom = 90;
        }else{
          this.zoom = 100;
        }

        let zoom = Math.round(this.$store.state.zoom * 100);
        if(Math.abs(this.zoom - zoom) < 20){
          this.zoom = zoom;
        }

        // 缩放
        this.screenZoom(this.zoom/100);

      },

      /**
       * @Author ZhangBin
       * @Description //TODO 屏幕放大缩小到指定比例
       * @Date 17:34 2022/8/26
       * @Param
       * @return
       **/
      screenZoom(zoom=1){
        if(zoom < this.minZoom/100) zoom = this.minZoom/100;
        else if(zoom > this.maxZoom/100) zoom = this.maxZoom/100;
        // document.body.style.zoom = zoom;
        // document.body.style.cssText += '; -moz-transform: scale(' + zoom + ');-moz-transform-origin: 0 0; ';
        console.log('screenZoom', zoom);
        document.getElementById('app').style.zoom = zoom;
        document.getElementById('app').style.cssText += '; -moz-transform: scale(' + zoom + ');-moz-transform-origin: 0 0; ';
        // 存储到本地缓存
        this.$store.dispatch("commitZoom", zoom);
        this.zoom = Math.round(zoom * 100);
      },

      /**
       * @Author ZhangBin
       * @Description //TODO 放大缩小
       * @Date 17:34 2022/8/26
       * @Param
       * @return
       **/
      upDownZoom(up=true){
        let zoom = parseFloat(this.$store.state.zoom);
        if(up){
          zoom += 0.05;
        }else{
          zoom -= 0.05;
        }
        this.screenZoom(zoom);
      },

      /**
       * @Author ZhangBin
       * @Description //TODO 修改级别
       * @Date 17:34 2022/8/26
       * @Param
       * @return
       **/
      updateZoom(){
        this.zoomButton = false;
      },

      /**
       * @Author ZhangBin
       * @Description //TODO 完成修改
       * @Date 17:34 2022/8/26
       * @Param
       * @return
       **/
      finishUpdate(){
        this.zoom = parseInt(this.zoom);
        this.zoomButton = true;
        this.screenZoom(this.zoom/100);
      }

		},// methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/Screen/ScreenScale.vue